import { memo, useMemo } from 'react';

import PropTypes from 'prop-types';

import Select from 'components/UI/Select/Select';

import styles from './Filters.module.scss';

const Filters = ({ options }) => {
  const filtersJSX = useMemo(
    () =>
      options.map(({ title, items = [], handleSelect, ...props }) => (
        <Select
          key={title}
          title={title}
          items={items}
          handleSelect={handleSelect}
          width={140}
          {...props}
        />
      )),
    [options],
  );

  return <div className={styles.wrapper}>{filtersJSX}</div>;
};

Filters.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]).isRequired,
      items: PropTypes.arrayOf(
        PropTypes.oneOfType([
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
          }),
          PropTypes.string,
        ]),
      ),
      handleSelect: PropTypes.func.isRequired,
      loading: PropTypes.bool,
      disabled: PropTypes.bool,
      multiple: PropTypes.bool,
      countTags: PropTypes.number,
    }),
  ).isRequired,
};

export default memo(Filters);
